import type { Survey } from '@api/surveys/utilities/types';

export const buildPreviewUrl = ({
  previewSelection,
  surveyId,
}: {
  previewSelection: PreviewSelection;
  surveyId: string;
}) => {
  const previewEndpoint = process.env.REACT_APP_SURVEY_PREVIEW_ENDPOINT;
  if (!previewEndpoint) return '';

  const previewEndpointUrl = new URL(previewEndpoint);
  previewEndpointUrl.searchParams.append('c', '-1');
  previewEndpointUrl.searchParams.append('public_survey_id', `preview_${surveyId}`);
  if (previewSelection?.quotaGroupId) {
    previewEndpointUrl.searchParams.set('quotaGroupId', previewSelection.quotaGroupId);
  }
  return previewEndpointUrl.toString();
};

export const getPreviewSelection = (survey: Survey) => {
  const defaultQuotaGroupId = survey?.groups?.[0]?.id;
  return {
    quotaGroupId: defaultQuotaGroupId,
  };
};

export interface PreviewSelection {
  quotaGroupId?: string;
}
